export const SIGN_UP_API = {
  SET_REQUEST: "ACTION.LOGIN.SET_REQUEST",
  SET_RESPONSE: "ACTION.LOGIN.SET_RESPONSE",
  SET_ERROR: "ACTION.LOGIN.SET_ERROR",
  SET_RETRY: "ACTION.LOGIN.SET_RETRY",
  RESET: "ACTION.LOGIN.RESET",
};

const SIGN_UP = {
  RESET_ALL: "ACTION.LOCAL.SIGN_UP.RESET_ALL",
  FIELD: {
    UPDATE: "ACTION.LOCAL.SIGN_UP.FIELD.UPDATE",
    CLEAR: "ACTION.LOCAL.SIGN_UP.FIELD.CLEAR",
  },
  FLAGS: {
    TOGGLE_COMPLETE: "ACTION.LOCAL.SIGN_UP.FLAGS.TOGGLE_COMPLETE",
    UPDATE_STEP: "ACTION.LOCAL.SIGN_UP.FLAGS.UPDATE_STEP",
    RESET: "ACTION.LOCAL.SIGN_UP.FLAGS.RESET",
  },
  SIGN_UP_API,
};

export default SIGN_UP;
